// 🔧 ticket_step.js
// ✅ Purpose: Pipeline step for the LGV Ticket Engine
// ✅ Features:
// - Executes the Ticket Engine when Tickets is selected
// - Integrates with shared DemoContext
// - Returns standardized pipeline results
// - Fully block-commented for clarity and future devs

import { runTicketEngine } from "../../engines/tickets";

export const createTicketStep = () => ({
  id: "ticket_builder",

  name: "Ticket Builder",

  label: "Ticket Builder",

  run: async (demoContext) => {
    console.log("🎫 Ticket Pipeline Step started.");

    const result = await runTicketEngine({
      demoContext,
    });

    console.log("✅ Ticket Pipeline Step completed.", {
      result,
    });

    return result;
  },
});